import React from "react";
import "./index.scss";
const Card = ({ children }) => {
  return <div className="card widget--card">{children}</div>;
};

export default Card;
